import React from 'react';
import PackageCard from './PackageCard';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function NextArrow(props) {
  const { className, style, onClick } = props;
  return <div className={className} style={{ ...style, display: 'block' }} onClick={onClick} />;
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return <div className={className} style={{ ...style, display: 'block' }} onClick={onClick} />;
}

export default class realEstateBannerMobile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeKey: 1
    };
  }

  render(props) {
    const settings = {
      className: 'slider variable-width',
      dots: true,
      infinite: true,
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />
    };
    return (
      <div>
        <div className='slider-container'>
          <Slider {...settings}>
            {Object.keys(this.props.productPackages).map((packageKey, packageIndex) => {
              let singlePackage = this.props.productPackages[packageKey];
              if (singlePackage.key !== 'trial' && singlePackage.enabled) {
                return (
                  <PackageCard
                    singlePackage={singlePackage}
                    packageIndex={packageIndex}
                    selectedIndustry={this.props.selectedIndustry}
                    onSelectPackage={this.props.onSelectPackage}
                    method={this.props.method}
                    isMobile={this.props.mobile}
                  />
                );
              }
              return '';
            })}
          </Slider>
        </div>
      </div>
    );
  }
}
